import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import ItemsNav from './Nav';
import ItemsNavDesign from './NavDesign';
import MobNav from './mobNav';
import { getLogo, isDesign } from '../../middleware/common-functions';
import { db } from '../../middleware/firebase';

const HISTORY_KEY = 'search_history';
const MAX_HISTORY = 10;

const getHistory = () => {
  try {
    return JSON.parse(localStorage.getItem(HISTORY_KEY)) || [];
  } catch {
    return [];
  }
};

const saveToHistory = (text) => {
  const trimmed = text.trim();
  if (!trimmed) return;
  let history = getHistory().filter((h) => h !== trimmed);
  history.unshift(trimmed);
  localStorage.setItem(HISTORY_KEY, JSON.stringify(history.slice(0, MAX_HISTORY)));
};

const SearchNav = () => {
  const [toggled, settoggled] = useState(true);
  const [toggled_b, settoggled_b] = useState(false);
  const [toggledFirst, settoggledFirst] = useState(false);
  const [toggledMob, settoggledMob] = useState(false);
  const [toggledMobSearch, settoggledMobSearch] = useState(false);
  const [cart_items, setcart_items] = useState(0);
  const [searchFocused, setSearchFocused] = useState(false);
  const [history, setHistory] = useState([]);
  const [assignedClasses, setassignedClasses] = useState([
    'navbar',
    'navbar-expand-md',
    'material-shadows',
    'fixed-top',
    'main_navbar',
    'pb-md-0',
    'scroll',
  ]);

  const routerHistory = useHistory();
  const location = useLocation();
  const logo = getLogo();
  const is_design = isDesign();

  useEffect(() => {
    if (!location.pathname.startsWith('/busqueda')) {
      const desktop = document.getElementById('searchInput');
      const mob = document.getElementById('searchInputMob');
      if (desktop) desktop.value = '';
      if (mob) mob.value = '';
    }
  }, [location.pathname]);

  useEffect(() => {
    const cart_items_local = JSON.parse(localStorage.getItem('cart'));
    if (cart_items_local) {
      setcart_items(cart_items_local.length);
    }
    document.getElementsByTagName('body')[0].onscroll = () => {
      updatesize();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updatesize = () => {
    const current_assignedClasses = [...assignedClasses];
    let scroll_value =
      document.documentElement.scrollTop || document.body.scrollTop;
    scroll_value =
      document.documentElement.scrollTop || document.body.scrollTop;
    if (
      (!toggledFirst && scroll_value >= 20) ||
      (scroll_value > 20 && toggled_b)
    ) {
      current_assignedClasses.push('top');
      settoggled_b(false);
      settoggled(true);
      settoggledFirst(true);
      setassignedClasses(current_assignedClasses);
    } else if (scroll_value <= 20 && toggled) {
      current_assignedClasses.pop();
      settoggled_b(true);
      settoggled(false);
      setassignedClasses(current_assignedClasses);
    }
  };

  const toggleMobNav = () => {
    settoggledMob(!toggledMob);
    settoggledMobSearch(false);
  };

  const toggleMobSeachFun = () => {
    if (!toggledMobSearch) {
      setTimeout(() => {
        document.getElementById('searchInputMob').focus();
      }, 100);
    }
    settoggledMobSearch(!toggledMobSearch);
  };

  const doSearch = async (text) => {
    const trimmed = text && text.trim();
    if (!trimmed) return;
    saveToHistory(trimmed);
    setHistory(getHistory());
    setSearchFocused(false);

    // Check for a single-link synonym redirect
    try {
      const snap = await db
        .collection('search-synonyms')
        .where('term', '==', trimmed.toLowerCase())
        .limit(1)
        .get();
      if (!snap.empty) {
        const links = snap.docs[0].data().links || [];
        if (links.length === 1) {
          routerHistory.push(links[0].url);
          return;
        }
      }
    } catch (_) { /* non-critical — fall through to normal search */ }

    routerHistory.push(`/busqueda?q=${encodeURIComponent(trimmed)}`);
  };

  const searchProductsPromt = (overrideText) => {
    if (overrideText) {
      doSearch(overrideText);
      return;
    }
    const desktopInput = document.getElementById('searchInput');
    const mobInput = document.getElementById('searchInputMob');
    const text = (desktopInput && desktopInput.value) || (mobInput && mobInput.value);
    if (mobInput && mobInput.value) mobInput.blur();
    doSearch(text);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') searchProductsPromt();
  };

  const handleFocus = () => {
    setHistory(getHistory());
    setSearchFocused(true);
  };

  const closeDropdown = () => setSearchFocused(false);

  const removeHistoryItem = (item) => {
    const updated = getHistory().filter((h) => h !== item);
    localStorage.setItem(HISTORY_KEY, JSON.stringify(updated));
    setHistory(updated);
  };

  const clearHistory = () => {
    localStorage.removeItem(HISTORY_KEY);
    setHistory([]);
  };

  const showDropdown = searchFocused && history.length > 0;

  return (
    <React.Fragment>
      <div
        className={`backdrop_nav ${showDropdown ? 'active' : ''}`}
        onClick={closeDropdown}
      ></div>
      <nav className={assignedClasses.join(' ')} id="main_navbar">
        <div className="container nav_container">
          <button
            className="btn d-md-none"
            type="button"
            onClick={toggleMobSeachFun}
          >
            <i className="fas fa-search"></i>
          </button>
          <Link className="navbar-brand smooth_scroll" to="/">
            <img src={logo} className="img-fluid" alt="Logo Mathasa" />
          </Link>
          <Link to="/cart" className="btn btn-cart d-md-none">
            <i className="fas fa-shopping-cart "></i>{' '}
            <span id="cart_items_cant_mob">{cart_items}</span>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            aria-label="Toggle navigation"
            onClick={toggleMobNav}
          >
            <i className="fas fa-bars"></i>
          </button>

          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="row w-100">
              <div className="col-6 search_results_container">
                <SearchBar
                  searchProductsPromt={searchProductsPromt}
                  handleKeyDown={handleKeyDown}
                  onFocus={handleFocus}
                />
                {searchFocused && history.length > 0 && (
                  <SearchHistory
                    history={history}
                    onSelect={searchProductsPromt}
                    onRemove={removeHistoryItem}
                    onClearAll={clearHistory}
                  />
                )}
              </div>
              <div className="col-6 text-right">
                <Link to="/cart" className="btn btn-cart">
                  <i className="fas fa-shopping-cart"></i>{' '}
                  <span id="cart_items_cant">{cart_items}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          {is_design ? <ItemsNavDesign /> : <ItemsNav />}
        </div>
        <MobNav is_active={toggledMob} toggleMobNav={toggleMobNav} />
        <SearchMob
          is_active={toggledMobSearch}
          searchProductsPromt={searchProductsPromt}
          handleKeyDown={handleKeyDown}
          handleFocus={handleFocus}
          history={history}
          searchFocused={searchFocused}
          onRemove={removeHistoryItem}
          onClearAll={clearHistory}
        />
      </nav>
    </React.Fragment>
  );
};

const SearchMob = ({
  searchProductsPromt,
  handleKeyDown,
  handleFocus,
  is_active,
  history,
  searchFocused,
  onRemove,
  onClearAll,
}) => {
  if (!is_active) return null;
  return (
    <div className="mob_search_bar search_results_container d-md-none">
      <SearchBar
        searchProductsPromt={searchProductsPromt}
        handleKeyDown={handleKeyDown}
        onFocus={handleFocus}
        is_mob
      />
      {searchFocused && history.length > 0 && (
        <SearchHistory
          history={history}
          onSelect={searchProductsPromt}
          onRemove={onRemove}
          onClearAll={onClearAll}
        />
      )}
    </div>
  );
};

const SearchBar = ({ searchProductsPromt, handleKeyDown, onFocus, is_mob }) => (
  <div className="input-group">
    <input
      type="text"
      id={is_mob ? 'searchInputMob' : 'searchInput'}
      className="form-control"
      placeholder="Busca Productos"
      aria-label="Busca Productos"
      aria-describedby="button-addon2"
      onKeyDown={handleKeyDown}
      onFocus={onFocus}
      autoComplete="off"
    />
    <div className="input-group-append">
      <button
        className="btn btn-light search_bar"
        type="button"
        onClick={() => searchProductsPromt()}
      >
        <i className="fas fa-search"></i>
      </button>
    </div>
  </div>
);

const SearchHistory = ({ history, onSelect, onRemove, onClearAll }) => (
  <div className="search_results search_history">
    <div className="search_history_header">
      <span className="search_history_label">Últimas búsquedas</span>
      <button className="search_history_clear_all" onClick={onClearAll}>
        Eliminar todas
      </button>
    </div>
    <div className="search_history_chips">
      {history.map((item) => (
        <div key={item} className="search_history_chip">
          <span onClick={() => onSelect(item)}>{item}</span>
          <button
            className="search_history_chip_remove"
            onClick={() => onRemove(item)}
            aria-label={`Eliminar ${item}`}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
      ))}
    </div>
  </div>
);

export default SearchNav;
